import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
    DIFFERENT_LANGUAGE_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL,
    DIFFERENT_LANGUAGE_PRICES_URL,
    DIFFERENT_LANGUAGE_PRIVACY_POLICY_URL,
    DIFFERENT_LANGUAGE_TERMS_AND_CONDITIONS_URL,
    GERMAN_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL,
    GERMAN_PRICES_URL,
    GERMAN_PRIVACY_POLICY_URL,
    GERMAN_TERMS_AND_CONDITIONS_URL,
} from '../../../../../aumico-lib-core-fe/src/lib';

@Component({
    selector: 'aumico-policy-and-subscription-controls',
    templateUrl: './policy-and-subscription-controls.component.html',
    styleUrls: ['./policy-and-subscription-controls.component.scss'],
})
export class PolicyAndSubscriptionControlsComponent {
    @Input() form!: UntypedFormGroup;
    @Input() localizations!: any;
    @Input() locale: string = 'de';

    get acceptPolicy(): UntypedFormControl {
        return this.form.get('acceptPolicy') as UntypedFormControl;
    }

    get privacyPolicyUrl(): string {
        return this.locale === 'de'
            ? GERMAN_PRIVACY_POLICY_URL
            : DIFFERENT_LANGUAGE_PRIVACY_POLICY_URL.replace('{locale}', this.locale);
    }

    get termsAndConditionsUrl(): string {
        return this.locale === 'de'
            ? GERMAN_TERMS_AND_CONDITIONS_URL
            : DIFFERENT_LANGUAGE_TERMS_AND_CONDITIONS_URL.replace('{locale}', this.locale);
    }

    get agreementOnOrderDataProcessingUrl(): string {
        return this.locale === 'de'
            ? GERMAN_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL
            : DIFFERENT_LANGUAGE_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL.replace('{locale}', this.locale);
    }

    get pricesUrl(): string {
        return this.locale === 'de'
            ? GERMAN_PRICES_URL
            : DIFFERENT_LANGUAGE_PRICES_URL.replace('{locale}', this.locale);
    }

    openLink(event: Event, url: string): void {
        event.stopPropagation();
        event.preventDefault();
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}
